import type { TFunction } from 'i18next';

/** persona-api caps the title at 100, on the DTO and on the column. Overflow fails the run. */
export const TITLE_MAX_LENGTH = 100;

// A factory, not property getters: both wizard hosts hand the result to `StepTracker`,
// which maps over it, so a getter would resolve once and freeze that language in.
export const buildStepLabels = (t: TFunction<'audiences'>): string[] => [
  t('focusGroup.stepLabels.setupResearch'),
  t('focusGroup.stepLabels.reviewQuestions'),
  t('focusGroup.stepLabels.runAndGenerate'),
];
